import { render, staticRenderFns } from "./CategoriaDialog.vue?vue&type=template&id=075b2d1e"
import script from "./CategoriaDialog.vue?vue&type=script&lang=js"
export * from "./CategoriaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports